import { ProductPageLayout } from '../components/ProductPageLayout';

export function AiInfluencerVideoBuilderPage() {
    return <ProductPageLayout productId="ai-influencer-video-builder" />;
}
